import React from "react";
import { motion } from "framer-motion";
import { Reveal, SectionLabel, SerifHeading } from "@/components/site/primitives";
import { EXPERIENCE } from "@/lib/site-data";

export default function ExperiencePage() {
  return (
    <div data-testid="page-experience" className="pt-32 md:pt-40 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <SectionLabel>Experience</SectionLabel>
            <SerifHeading className="mt-6">
              A career shaped across real estate, technology, and civic law.
            </SerifHeading>
          </div>
          <div className="lg:col-span-5">
            <p className="text-muted-foreground leading-relaxed">
              Six years of practice across in-house counsel roles, chamber
              apprenticeships, and freelance advisory — with clients ranging
              from developers to international founders.
            </p>
          </div>
        </div>

        <div className="mt-20 relative">
          {/* vertical line */}
          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true }}
            style={{ transformOrigin: "top" }}
            className="absolute left-3 md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-border"
            aria-hidden
          />

          <ul className="space-y-16 md:space-y-24">
            {EXPERIENCE.map((e, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <li
                  key={e.org + e.period}
                  data-testid={`exp-item-${idx}`}
                  className="relative pl-10 md:pl-0"
                >
                  {/* dot */}
                  <motion.span
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.1, duration: 0.5 }}
                    viewport={{ once: true }}
                    className="absolute left-2 md:left-1/2 md:-translate-x-1/2 top-3 h-3 w-3 bg-gold rounded-full ring-4 ring-background"
                    aria-hidden
                  />

                  <div className="md:grid md:grid-cols-2 md:gap-16">
                    <div className={isLeft ? "md:pr-12 md:text-right" : "md:col-start-2 md:pl-12"}>
                      <Reveal>
                        <div className="eyebrow text-[#B8912C]">{e.period}</div>
                        <h3 className="mt-3 font-serif text-2xl md:text-3xl text-navy leading-tight">
                          {e.org}
                        </h3>
                        <div className="mt-2 text-sm uppercase tracking-[0.22em] text-navy/70">
                          {e.role}
                        </div>
                      </Reveal>
                    </div>
                    <div className={isLeft ? "md:col-start-2 md:pl-12 mt-4 md:mt-0" : "md:row-start-1 md:pr-12 md:text-right mt-4 md:mt-0"}>
                      <Reveal delay={0.05}>
                        <ul className={`space-y-2 text-sm text-muted-foreground ${!isLeft ? "md:ml-auto" : ""}`}>
                          {e.points.map((p) => (
                            <li key={p} className="leading-relaxed">
                              {p}
                            </li>
                          ))}
                        </ul>
                      </Reveal>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
